import { type NavigateOptions, useNavigate } from 'react-router-dom';

import { filterDuplicates } from '@service-initiation/shared-utils-helpers';

import { useFlowMetadata } from './useFlowMetadata';

type NavigateOptionsWithQueryParams = NavigateOptions & {
  queryParams?: URLSearchParams;
};
export const useGoToStep = () => {
  const navigate = useNavigate();
  const { setValue } = useFlowMetadata();

  return {
    goToStep: (step: string, options?: NavigateOptionsWithQueryParams) => {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: 0,
      });
      setValue((prev) => ({
        ...prev,
        visitedPaths: filterDuplicates([...prev.visitedPaths, step]),
      }));
      navigate(
        `${step}${
          options?.queryParams?.toString()
            ? `?${options.queryParams.toString()}`
            : ''
        }`,
        options
      );
    },
  };
};
